import { AddSubstitutionPartParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addSubstitutionPart/addSubstitutionPartQuery.type';
import { AddSubstitutionPartQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addSubstitutionPart/addSubstitutionPartQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const useAddSubstitutionPartQueryOption = () => {
  return useMutation({
    mutationFn: (params: AddSubstitutionPartParams) =>
      AddSubstitutionPartQueryFunction(params),
    mutationKey: ['addSubstitutionPartQueryOption'],
  });
};
